
import IDialog from "@/components/dialog/IDialog.vue";
import { useI18n } from "vue-i18n";
import AppHeader from "@/components/header/AppHeader.vue";
import Cases from "../../modules/cases/Cases.component.vue";
import CaseDiagnosisForm from "../../components/CaseDiagnosisForm.vue";
import HeatmapsPanel from "../../modules/heatmaps/HeatmapsPanel.component.vue";
import HeatmapsLegend from "../../modules/heatmaps/HeatmapsLegend.component.vue";
import HeatmapsViewer from "../../modules/heatmaps/HeatmapsViewer.component.vue";
import ViewerTools from "../../modules/viewer/ViewerTools.component.vue";
import AlertsPanel from "../../modules/alerts/AlertsPanel.component.vue";
import StatisticsScreen from "@/modules/statistics/StatisticsScreen.vue";
import Gallery from "../poi/Gallery.component.vue";
import { EventBus } from "@/eventBus";
import { mapActions, mapGetters, mapState } from "vuex";
import { RootGetters } from "@/store/getters";
import { RootActions } from "@/store/actions";
import { defineComponent } from "vue";
import CaseReport from "@/modules/reports/case/CaseReport.vue";
import SlideList from "@/modules/slides/components/SlideList.vue";
import Insights from "@/modules/insights/Insights.vue";
import { BFF_BASE_PATH } from "@/core/utils";
import HeatmapLegendQuantification from "../heatmaps/HeatmapLegendQuantification.vue";
import { modalTypes } from "@/components/dialog/modalTypes";

export default defineComponent({
  components: {
    CaseReport,
    AppHeader,
    CaseDiagnosisForm,
    HeatmapsPanel,
    HeatmapsLegend,
    HeatmapsViewer,
    ViewerTools,
    AlertsPanel,
    Cases,
    SlideList,
    StatisticsScreen,
    Gallery,
    Insights,
    HeatmapLegendQuantification,
    IDialog,
  },
  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: "local",
    });
    return { t };
  },
  data() {
    return {
      modalTypes,
    };
  },
  computed: {
    ...mapState(["currentSlide", "isError", "activeSlideId", "isQuantificationLegend", "isVisible"]),
    ...mapGetters({
      isStatisticsScreenDisplayed: RootGetters.GET_IS_STATISTICS_SCREEN,
      isCaseReportDisplayed: RootGetters.IS_CASE_REPORT_DISPLAYED,
      config: RootGetters.CONFIG,
      activeCase: RootGetters.GET_ACTIVE_CASE,
      activeSlide: RootGetters.ACTIVE_SLIDE,
      isFirstRead: RootGetters.IS_FIRST_READ,
    }),
  },
  methods: {
    ...mapActions({
      setError: RootActions.SET_ERROR,
      fetchHeatmapsConfig: RootActions.FETCH_HEATMAPS_CONFIG,
      fetchLabeling: RootActions.FETCH_LABELING,
    }),
    fetchGlobals(): void {
      fetch(`${BFF_BASE_PATH}/globals`)
        .then((response) => {
          if (!response.ok) {
            throw Error(response.statusText);
          }
          return response.json();
        })
        .then((globals) => {
          this.$store.commit("globals", globals);
          EventBus.emit("event-bridge-api", {
            eventName: "app-ready",
            data: { config: this.config, globals },
          });
        })
        .catch((error) => this.setError("failed fetching globals"));
    },
  },
  beforeMount() {
    this.fetchHeatmapsConfig();
    this.fetchLabeling();
  },
  mounted() {
    this.fetchGlobals();
  },
});
